/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `SchoolIconProps` interface defines the properties for the SchoolIcon component.
 */
interface SchoolIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "school" — outlined, weight 300.
 * Graduation cap icon for the Wissen (Knowledge) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const SchoolIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'SchoolIcon',
    width
}: SchoolIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m479.38-166.16-267.3-146.3v-216.93L81.54-600l397.84-216.92L878.46-600v285.46h-45.39v-258.92l-86.38 44.07v216.93l-267.31 146.3Zm0-268.38L782.85-600 479.38-763.23 177.15-600l302.23 165.46Zm0 216.92 221.93-122v-162.23l-221.93 118.7-221.92-120.31v163.84l221.92 122Zm.62-216.92Zm-.62 60.54Zm0 0Z" />
    </svg>
);

SchoolIcon.displayName = 'SchoolIcon';